import { createContext } from 'react';
import counterpart from 'counterpart';

const LanguageContext = createContext(counterpart.getLocale());

export default LanguageContext;
